import { MutateFn } from '@diritto/common/base/mutateFunction';
import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { ProfileFollowApi } from 'api/ApiHelper';
import { useTrackingState } from 'contexts/TrackingProvider';
import { profileFollowQueryKey } from 'queries/profileFollow/queryKey';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useFollowProfileMutation = (profileId: number, callback: MutateFn) => {
  const { tracker } = useTrackingState();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: profileFollowQueryKey.profileFollow(profileId),
    mutationFn: () => ProfileFollowApi.followProfile(profileId),
    onMutate: callback.onMutate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: profileFollowQueryKey.profileFollow(profileId) });
      tracker.track(TrackingEventType.FollowProfile, { profileId });
    },
    onError: callback.onError,
  });
};
